export const BASE64_NOTOSANKR_FONT_REGULAR_DATA = 'https://s3.us-west-1.amazonaws.com/gooverai.com/assets/NotoSanKr-Regular.txt';
